//
// Copyright (c) 2025 Comcast
//

import { useCallback } from 'react'
import { useParams } from 'react-router'
import PropTypes from 'prop-types'
import startCase from 'lodash/startCase'

import {
  useLazyQuickSearchQuery,
} from 'api/tickets'

const useParentField = ({ formRef }) => {
  const [triggerQuickSearch] = useLazyQuickSearchQuery()

  const params = useParams()
  const ticketingSystemDisplayId = params.ticketingSystemDisplayId

  const fetchParentOptions = useCallback(async ({ ticketType, parentValue }) => {
    const data = await triggerQuickSearch({
      ticketingSystemDisplayId: ticketingSystemDisplayId,
      currentType: ticketType,
      canBeParent: true,
      searchTerm: parentValue,
    }).unwrap()

    const parentOptions = data.tickets?.map(item => ({
      value: item.id,
      shortLabel: item.number,
      label: `${item.number} ${item.title}`,
    })) || []
    return parentOptions
  }, [ticketingSystemDisplayId, triggerQuickSearch])

  const getParentFieldParams = useCallback(({ parentField }) => {
    const onLoadParentOptionsFunc = async (inputValue, callback) => {
      const formState = formRef.current?.getState()
      const currentTicketType = formState?.values?.type

      if (!currentTicketType) {
        console.error('Type field is missing in form values')
        callback([])
        return
      }

      const parentOptions = await fetchParentOptions({
        ticketType: currentTicketType,
        parentValue: inputValue,
      })
      callback(parentOptions)
    }

    const parentFieldParams = {
      key: parentField.id.toString(),
      name: parentField.name,
      label: startCase(parentField.name),
      type: 'selectAsync',
      placeholder: parentField.placeholder,
      required: parentField.required,
      tooltip: parentField.tooltiptext,
      onLoadOptions: onLoadParentOptionsFunc,
    }

    return parentFieldParams
  }, [fetchParentOptions, formRef])
  return ({
    getParentFieldParams: getParentFieldParams,
  })
}

useParentField.propTypes = {
  formRef: PropTypes.object,
}

export { useParentField }
